import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class CompareProductItem extends HTMLElement {
  connectedCallback() {
    const compareProductSelect = this.querySelector('[compare-product-select]')
    const compareProductCard = this.querySelector('[compare-product-card]');

    if (compareProductSelect === null || compareProductCard === null) return;
    compareProductSelect.addEventListener('change', (evt)=>{
      compareProductCard.innerHTML = document.querySelector(`#compare-card-${compareProductSelect.value}`)?.innerHTML
    })
  }
  disconnectedCallback() {
  }
}
if (!customElements.get('compare-product-item')) {
  customElements.define('compare-product-item', CompareProductItem);
}

class CompareProduct extends HTMLElement {
  connectedCallback() {
    this.preselectProducts();

    const productInformation = document.querySelector('.product-information')
    if(  productInformation !== null ) {
      const productSection  =productInformation.closest('.shopify-section');
      if (!productSection) return;
      // closestSection.addEventListener('variant:update', this.preselectProducts);
      productSection.addEventListener(ThemeEvents.variantUpdate, this.preselectProducts);
    }
  }

  preselectProducts() {
    const productSelects = this.querySelectorAll('[compare-product-select]');
    let preselectedProducts = ['daily-backpack', 'daily-plus', 'max-edc'];
    if( this.dataset.productHandle !== '' ) {
      preselectedProducts =[this.dataset.productHandle];
    }
    let index = 0;
    preselectedProducts.forEach((preselectedProduct)=>{
      if( typeof(productSelects[index]) !== 'undefined' ) {
        productSelects[index].value = preselectedProducts[index];
        productSelects[index].dispatchEvent( new Event('change') );
        index++;
      }
    });

    if( typeof(this.dataset.selectedVariantId) !== 'undefined' ) {
      const variantId = this.dataset.selectedVariantId;
      if( this.querySelector(`compare-product-item input[data-variant-id="${variantId}"]`) !== null ) {
        this.querySelector(`compare-product-item input[data-variant-id="${variantId}"]`).checked = true;
        this.querySelector(`compare-product-item input[data-variant-id="${variantId}"]`).closest('product-card').querySelector(`swatches-variant-picker-component`).dispatchEvent( new Event('change') );
      }
    }
  }

  disconnectedCallback() {
  }
}
if (!customElements.get('compare-product')) {
  customElements.define('compare-product', CompareProduct);
}

class CompareViewToggle extends HTMLElement {
  connectedCallback() {
    // const button = this.querySelector('button')
    this.addEventListener('click', (evt)=>{
      evt.preventDefault()
      evt.stopPropagation()

      const closestSection = this.closest('.shopify-section, dialog');
      if (!closestSection) return;

      if (this.dataset.view==='compare') {
        closestSection.querySelector('.collection-view--compare').style.display = 'block'
        closestSection.querySelector('.collection-wrapper').style.display = 'none'
      } else {
        closestSection.querySelector('.collection-view--compare').style.display = 'none'
        closestSection.querySelector('.collection-wrapper').style.display = 'block'
      }
    })
  }
  disconnectedCallback() {
  }
}
if (!customElements.get('compare-view-toggle')) {
  customElements.define('compare-view-toggle', CompareViewToggle);
}

